import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { toast } from 'react-toastify';
import axios from 'axios';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../../src/config/firebase';
import IconButton from 'components/common/IconButton';
import PageHeader from 'components/common/PageHeader';
import FileUpload from 'components/doc-components/FileUpload';
import FalconComponentCard from 'components/common/FalconComponentCard';

const EditTender = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileUrlAwarded, setFileUrlAwarded] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    closingDate: '',
    reference: '',
    contact: '',
    tel: '',
    email: '',
    description: '',
    closingDateDD: '',
    closingDateMM: '',
    closingDateYYYY: '',
    closingTimeHH: '',
    closingTimeMM: '',
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
        setFormData({
          ...formData,
          user_id: uid,
        });
      } else {
        navigate('/login');
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const id = window.location.pathname.split('/').pop();

      if (id) {
        try {
          const apiUrl = `${process.env.REACT_APP_API_URL}`;

          const response = await axios.get(`${apiUrl}/tenders/id/${id}`);

          if (response.data) {
            const eventData = response.data[0];
            console.log('eventData', eventData);

            setFormData({
              id: eventData.id,
              name: eventData.name,
              status: eventData.status,
              fee: eventData.fee,
              hits: eventData.hits,
              tel: eventData.tel,
              hits: eventData.hits,
              reference: eventData.reference,
              description: eventData.description,
              contact: eventData.contact,
              attachment: eventData.attachment,
              attachment_awarded: eventData.attachment_awarded,
              date_added: eventData.date_added,
              closingDateDD: eventData.closing_date.split('/')[0],
              closingDateMM: eventData.closing_date.split('/')[1],
              closingDateYYYY: eventData.closing_date.split('/')[2],
              closingTimeHH: eventData.closing_time.split(':')[0],
              closingTimeMM: eventData.closing_time.split(':')[1],
              closing_date: eventData.closing_date,
              closing_time: eventData.closing_time,
              enabled: eventData.enabled === 'false' ? false : true,
              enabled: eventData.enabled,
              email: eventData.email,
            });
            setLoading(false);
          }
        } catch (err) {
          console.log('Error', err);
          setLoading(false);
        }
      } else {
        navigate('/tenders/list');
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const date = `${formData.closingDateDD}/${formData.closingDateMM}/${formData.closingDateYYYY}`;

    const { closingDateDD, closingDateMM, closingDateYYYY } = formData;
    const inputDate = new Date(closingDateYYYY, closingDateMM - 1, closingDateDD);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // set time to 00:00:00.000

    try {
      if (inputDate < today || closingDateYYYY < today.getFullYear() || closingDateMM > 12 || closingDateDD > 31) {
        console.log('inputDate', inputDate);
        toast.error('Closing date is invalid.');
        return;
      }
    } catch (error) {
      toast.error('Closing date is invalid.');
      return;
    }

    const { closingTimeHH, closingTimeMM } = formData;
    const closingTime = `${closingTimeHH}:${closingTimeMM}`;

    try {
      const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/;
      if (!timePattern.test(closingTime)) {
        toast.error('Closing time is invalid.');
        return;
      }
    } catch (error) {
      toast.error('Closing time is invalid.');
      return;
    }

    try {
      let formData2 = new FormData();
      formData2.append('name', formData.name);
      formData2.append('closing_date', date);
      formData2.append('closing_time', closingTime);
      formData2.append('reference', formData.reference);
      formData2.append('contact', formData.contact);
      formData2.append('tel', formData.tel);
      formData2.append('email', formData.email);
      formData2.append('description', formData.description);
      formData2.append('fileUrl', fileUrl);
      formData2.append('attachment', fileUrl);
      formData2.append('attachment_awarded', fileUrlAwarded);
      formData2.append('hits', formData.hits);
      formData2.append('fee', formData.fee);
      formData2.append('status', formData.status);

      const response = await axios.put(`${process.env.REACT_APP_API_URL}/tenders/id/${formData.id}`, formData2);

      if (response) {
        toast.success('Tender updated successfully', {
          theme: 'colored',
        });

        setFormData({
          ...formData,
          name: '',
          closingDate: '',
          reference: '',
          contact: '',
          tel: '',
          email: '',
          description: '',
          closingDateDD: '',
          closingDateMM: '',
          closingDateYYYY: '',
          closingTimeHH: '',
          closingTimeMM: '',
        });
        setFileUrl(null);
        setFileUrlAwarded(null);

        navigate('/tenders/list');
      }
    } catch (err) {
      console.log('Error', err.message);
    }
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    if (name === 'name') {
      setFormData({
        ...formData,
        [name]: value,
        downloadTitle: value.replace(/ /g, '_'),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  return (
    <>
      <PageHeader
        title="Edit a Tender"
        description="The updated Tender details will be shown on the Tender's page"
        className="mb-3"
      ></PageHeader>

      <FalconComponentCard>
        <FalconComponentCard.Header title="Details" light={false} noPreview={true}></FalconComponentCard.Header>
        <Form onSubmit={handleSubmit}>
          {!loading ? (
            <FalconComponentCard.Body>
              <Row>
                <Col lg="12">
                  <Form.Group>
                    <Form.Label>
                      Name <span className="required-asterisk">*</span>
                    </Form.Label>
                    <Form.Control
                      size="lg"
                      type="text"
                      placeholder=""
                      name="name"
                      onChange={handleFieldChange}
                      defaultValue={formData.name}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <Form.Group>
                    <Form.Label>
                      Description <span className="required-asterisk">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      size="lg"
                      type="text"
                      placeholder=""
                      name="description"
                      onChange={handleFieldChange}
                      required
                      defaultValue={formData.description}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  <Form.Group>
                    <Form.Label>
                      Closing Date <span className="required-asterisk">*</span>
                    </Form.Label>
                    <Row>
                      <Col>
                        <Form.Control
                          maxLength="2"
                          size="lg"
                          type="text"
                          placeholder="DD"
                          name="closingDateDD"
                          onChange={handleFieldChange}
                          required
                          defaultValue={formData.closingDateDD}
                        />
                      </Col>
                      <Col>
                        <Form.Control
                          maxLength="2"
                          size="lg"
                          type="text"
                          placeholder="MM"
                          name="closingDateMM"
                          onChange={handleFieldChange}
                          required
                          defaultValue={formData.closingDateMM}
                        />
                      </Col>
                      <Col>
                        <Form.Control
                          maxLength="4"
                          size="lg"
                          type="text"
                          placeholder="YYYY"
                          name="closingDateYYYY"
                          onChange={handleFieldChange}
                          required
                          defaultValue={formData.closingDateYYYY}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
                <Col lg="6">
                  <Form.Group>
                    <Form.Label>
                      Closing time <span className="required-asterisk">*</span>
                    </Form.Label>
                    <Row>
                      <Col>
                        <Form.Control
                          maxLength="2"
                          size="lg"
                          type="text"
                          placeholder="HH"
                          name="closingTimeHH"
                          onChange={handleFieldChange}
                          required
                          defaultValue={formData.closingTimeHH}
                        />
                      </Col>
                      <Col>
                        <Form.Control
                          maxLength="2"
                          size="lg"
                          type="text"
                          placeholder="MM"
                          name="closingTimeMM"
                          onChange={handleFieldChange}
                          required
                          defaultValue={formData.closingTimeMM}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  <Form.Group>
                    <Form.Label>
                      Reference <span className="required-asterisk">*</span>
                    </Form.Label>
                    <Form.Control
                      size="lg"
                      type="text"
                      placeholder=""
                      name="reference"
                      onChange={handleFieldChange}
                      required
                      defaultValue={formData.reference}
                    />
                  </Form.Group>
                </Col>
                <Col lg="4">
                  <Form.Group>
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                      size="md"
                      className="mb-3"
                      name="status"
                      onChange={handleFieldChange}
                      defaultValue={formData.status}
                    >
                      <option key={'NEW'} value={'NEW'}>
                        New
                      </option>
                      <option key={'RECEIVED'} value={'RECEIVED'}>
                        Received
                      </option>
                      <option key={'AWARDED'} value={'AWARDED'}>
                        Awarded
                      </option>
                      <option key={'CLOSED'} value={'CLOSED'}>
                        Closed
                      </option>
                      <option key={'CANCELLED'} value={'CANCELLED'}>
                        Cancelled
                      </option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  <Form.Group>
                    <Form.Label>
                      Contact Person <span className="required-asterisk">*</span>
                    </Form.Label>
                    <Form.Control
                      size="lg"
                      type="text"
                      placeholder=""
                      name="contact"
                      onChange={handleFieldChange}
                      required
                      defaultValue={formData.contact}
                    />
                  </Form.Group>
                </Col>
                <Col lg="6">
                  <Form.Group>
                    <Form.Label>
                      Telephone <span className="required-asterisk">*</span>
                    </Form.Label>
                    <Form.Control
                      size="lg"
                      type="text"
                      placeholder=""
                      name="tel"
                      onChange={handleFieldChange}
                      required
                      defaultValue={formData.tel}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  <Form.Group>
                    <Form.Label>
                      Email <span className="required-asterisk">*</span>
                    </Form.Label>
                    <Form.Control
                      size="lg"
                      type="email"
                      placeholder=""
                      name="email"
                      defaultValue={formData.email}
                      onChange={handleFieldChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  <Form.Label>Attachment awarded pdf</Form.Label>
                  <br />
                  {formData.attachment_awarded ? (
                    <>
                      <Link to={formData.attachment_awarded} target="_blank">
                        View current attachment awarded pdf
                      </Link>
                      <br />
                      <br />
                    </>
                  ) : (
                    <>
                      No attachment awarded pdf
                      <br />
                      <br />
                    </>
                  )}
                  <FileUpload category={'tenders'} setFileUrl={setFileUrl} />
                </Col>

                <Col lg="6">
                  <Form.Label>Attachment pdf</Form.Label>
                  <br />
                  {formData.attachment ? (
                    <>
                      <Link to={formData.attachment} target="_blank">
                        View current attachment pdf
                      </Link>
                      <br />
                      <br />
                    </>
                  ) : (
                    <>
                      No attachment pdf
                      <br />
                      <br />
                    </>
                  )}
                  <FileUpload category={'tenders_awarded'} setFileUrl={setFileUrlAwarded} />
                </Col>
              </Row>
              <Row>
                <Col lg="6" className="mt-4 mb-3 ml-3">
                  <Form.Group>
                    <IconButton
                      className="mb-1"
                      variant="falcon-default"
                      size="lg"
                      icon="plus"
                      transform="shrink-3"
                      type="submit"
                    >
                      Submit
                    </IconButton>
                  </Form.Group>
                </Col>
              </Row>
            </FalconComponentCard.Body>
          ) : (
            <FalconComponentCard.Body>
              <Spinner animation="border" variant="primary" />
            </FalconComponentCard.Body>
          )}
        </Form>
      </FalconComponentCard>
    </>
  );
};

export default EditTender;
